import PropTypes from 'prop-types';
import React, { useEffect, useCallback, memo } from 'react';
import { Map, List } from 'immutable';
import { connect } from 'react-redux';

import Popups from '../../components/Popup';
import { unwrap } from '../../utils/ChangeSpy';
import {
  loadIndustryTags,
  selectTag,
  toggleTagList,
  reset as resetIndustry,
  selectTags,
} from '../../actions/industryTag';
import {
  selectBusinessModel,
  mergeBusinessModel,
  resetBusinessModels,
  loadBusinessModels,
} from '../../actions/company/companyTarget';
import { usePopupContext } from '../../contexts/PopupContext';

const TagsManagementPopupContainer = ({
  popup,
  tags,
  models,
  loadIndustryTags,
  selectTag,
  toggleTagList,
  resetIndustry,
  selectTags,
  selectBusinessModel,
  mergeBusinessModel,
  resetBusinessModels,
  loadBusinessModels,
}) => {
  const { closePopup, onClosePopup } = usePopupContext();

  useEffect(() => {
    const addNew = popup.getIn(['props', 'addNew']);
    const selectedTags = popup.getIn(['props', 'selectedTags'], Map()).toJS();
    const selectedModels = popup.getIn(['props', 'selectedModels'], Map()).toJS();

    if (popup.getIn(['props', 'cb'])) {
      onClosePopup(popup.getIn(['props', 'cb']));
    }

    if (tags.size === 0) {
      loadIndustryTags(selectedTags);
    } else if (!addNew) {
      selectTags(selectedTags);
    }

    if (models.size === 0) {
      loadBusinessModels(selectedModels);
    } else if (!addNew) {
      mergeBusinessModel(selectedModels);
    }
  }, []);

  const getSelectedTags = useCallback(tags => {
    const result = [];

    tags.forEach(tag => {
      if (tag.get('checked')) {
        result.push(tag.toJS());
      }
      tag.get('children', List()).forEach(child => {
        if (child.get('checked')) {
          result.push(child.toJS());
        }
      });
    });

    return result;
  }, []);

  const getSelectedModels = useCallback(models => {
    const result = [];

    unwrap(models).forEach(model => {
      if (model.get('checked')) {
        result.push(model.toJS());
      }
    });

    return result;
  }, []);

  const handleClose = useCallback(() => {
    const addNew = popup.getIn(['props', 'addNew']);
    const updateBack = popup.getIn(['props', 'callback']);

    if (!addNew) {
      updateBack(getSelectedTags(tags), getSelectedModels(models));
      resetIndustry();
      resetBusinessModels();
    }
    closePopup();
  }, [popup, tags, models, resetIndustry, resetBusinessModels, getSelectedTags, getSelectedModels, closePopup]);

  const handleChange = useCallback(
    (id, parentId) => {
      selectTag(id, parentId);
    },
    [selectTag],
  );

  const handleModelChange = useCallback(
    id => {
      selectBusinessModel(id);
    },
    [selectBusinessModel],
  );

  const handleClick = useCallback(
    (id, ids) => {
      toggleTagList(id, ids);
    },
    [toggleTagList],
  );

  const clientView = popup.getIn(['props', 'clientView']);

  return (
    <Popups.TagsManagementPopup
      businessModels={models}
      clientView={clientView}
      onChange={handleChange}
      onClick={handleClick}
      onClose={handleClose}
      onModelChange={handleModelChange}
      tags={tags}
    />
  );
};

TagsManagementPopupContainer.propTypes = {
  models: PropTypes.instanceOf(Map).isRequired,
  tags: PropTypes.instanceOf(List).isRequired,
};

const mapStateToProps = state => ({
  models: state.businessModels.get('models'),
  tags: state.industryTags.get('tags'),
  loading: state.industryTags.get('loading'),
  saving: state.industryTags.get('saving'),
});

export { TagsManagementPopupContainer };
export default connect(mapStateToProps, {
  loadIndustryTags,
  selectTag,
  toggleTagList,
  resetIndustry,
  selectTags,
  selectBusinessModel,
  mergeBusinessModel,
  resetBusinessModels,
  loadBusinessModels,
})(memo(TagsManagementPopupContainer));
